export default "__VITE_ASSET__BjdqXOMW__$_?imageSize__"